import { Component } from '@builder.io/sdk/dist/src/builder.class.d';

import { lazyLoadDefaultConfig } from '../utils/constants';
import { createFontConfigInputs } from './fontConfig';

export const config: Component = {
    name: 'Asset Type Card',
    inputs: [
        {
            name: 'height',
            type: 'string',
            enum: ['auto', '200px', '300px', '400px', '500px', '30vh', '50vh', '75vh', '100vh', '100%'],
            defaultValue: '400px',
            helperText: 'Card height (choose from preset values)',
        },
        {
            name: 'backgroundType',
            type: 'string',
            enum: ['image', 'video'],
            required: true,
            defaultValue: 'image',
            helperText: 'Choose whether to use an image or video as background',
        },
        {
            name: 'backgroundImage',
            type: 'file',
            allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
            defaultValue: '',
            helperText: 'Background image (required if background type is image)',
            showIf: (options) => options.get('backgroundType') === 'image',
        },
        {
            name: 'backgroundVideo',
            type: 'file',
            allowedFileTypes: ['mp4', 'webm'],
            defaultValue: '',
            helperText: 'Background video (required if background type is video)',
            showIf: (options) => options.get('backgroundType') === 'video',
        },
        {
            name: 'posterImage',
            type: 'file',
            allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
            defaultValue: '',
            helperText: 'Poster/preview image for video background (optional)',
            showIf: (options) => options.get('backgroundType') === 'video',
        },
        {
            name: 'backgroundPosition',
            type: 'string',
            enum: ['cover', 'contain', 'fill', 'center', 'top', 'bottom', 'left', 'right'],
            defaultValue: 'cover',
            helperText: 'How the background image/video should be positioned and sized',
        },
        {
            name: 'imageAlt',
            type: 'string',
            defaultValue: '',
            helperText: 'Alternative text for accessibility and SEO (applies to background images and poster images)',
        },
        {
            name: 'showGradient',
            type: 'boolean',
            defaultValue: true,
            helperText: 'Show gradient overlay for better text readability',
        },
        {
            name: 'gradientStartOpacity',
            type: 'number',
            defaultValue: 0,
            helperText:
                'Start opacity percentage (0-100%). Controls the opacity at the beginning of the gradient (2.08% position).',
            min: 0,
            max: 100,
            showIf: (options) => options.get('showGradient'),
        },
        {
            name: 'gradientEndOpacity',
            type: 'number',
            defaultValue: 20,
            helperText:
                'End opacity percentage (0-100%). Controls the opacity at the end of the gradient (76.85% position).',
            min: 0,
            max: 100,
            showIf: (options) => options.get('showGradient'),
        },
        {
            name: 'title',
            type: 'string',
            defaultValue: '',
            helperText: 'Optional title text displayed over the background',
        },
        ...createFontConfigInputs(),
        {
            name: 'titleColor',
            type: 'color',
            defaultValue: '#ffffff',
            helperText: 'Color for the title text',
        },
        {
            name: 'link',
            type: 'string',
            defaultValue: '',
            helperText: 'Optional URL to wrap the entire card in a link. Accepts absolute or relative paths.',
        },
        {
            ...lazyLoadDefaultConfig,
        },
        {
            name: 'Identifier',
            type: 'string',
            enum: ['Shell'],
            defaultValue: 'Shell',
            advanced: true,
            onChange: (_, context) => {
                context.set('Identifier', 'Shell');
            },
            helperText: "Identifier for the repo, don't change this",
        },
    ],
    canHaveChildren: true,
    defaultChildren: [],
};
